export interface IdentityProvider {
  targetUrl: string;
  formEntries: FormEntries;
}

export interface BaseInformationsResponse {
  version: string;
  authMethodTypes: string[];
}

export interface FormEntries {
  [key: string]: string;
}

export interface MockPlayerIdentityResponse {
  landingUrl?: string;
  identityToken: string;
}

export interface PlayerIdentity {
  name: string;
  birthDate: string;
  govtId: string;
  serviceType: string;
  providerType: string;
}

export class IdentityTokenError extends Error {
  errorCode = 401;

  constructor(message: string) {
    super(message);

    // required to set explicitly for instanceof checks
    Object.setPrototypeOf(this, IdentityTokenError.prototype);
  }
}

const JSONHeaders = {
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
};

/***
 * Class to handle identity functionality
 */

/* eslint-disable no-console */
export default class IdentityService {
  static async postMockPlayerIdentity(
    playerIdentity: PlayerIdentity,
    callbackUrl?: string
  ): Promise<MockPlayerIdentityResponse> {
    try {
      const res = await fetch(
        `${
          process.env.IDENTITY_SERVER_URL
        }/internal/mock-identity-provider/v1/player-identities?callbackUrl=${encodeURIComponent(
          callbackUrl
        )}`,
        {
          method: 'POST',
          body: JSON.stringify(playerIdentity),
          headers: JSONHeaders,
          credentials: 'include',
        }
      );

      return await res.json();
    } catch (error) {
      throw new IdentityTokenError(error.message);
    }
  }

  static async getBaseInformations(
    serviceType: string
  ): Promise<BaseInformationsResponse> {
    try {
      const res = await fetch(
        `${
          process.env.IDENTITY_SERVER_URL
        }/base-information/v1/clients/${serviceType}`,
        {
          method: 'GET',
          credentials: 'include',
        }
      );
      if (res.status !== 200) {
        throw Error(res.statusText);
      }
      return await res.json();
    } catch (error) {
      throw new IdentityTokenError(error.message);
    }
  }

  static async getIdentityProvider(
    providerType: string,
    serviceType: string,
    callbackUrl?: string
  ): Promise<IdentityProvider> {
    const data = {
      providerType,
      serviceType,
      callbackUrl,
    };

    try {
      const res = await fetch(
        `${
          process.env.IDENTITY_SERVER_URL
        }/identity-provider/v2/identity-providers`,
        {
          method: 'POST',
          body: JSON.stringify(data),
          headers: JSONHeaders,
          credentials: 'include',
        }
      );
      if (res.status !== 200) {
        throw Error(res.statusText);
      }
      return await res.json();
    } catch (error) {
      throw new IdentityTokenError(error.message);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/services/identity-service.ts